import './App.scss';
import AppRouter from './AppRouter';

const App = () => {
  return (
    <div className="app">
      <AppRouter/>
    </div>
  );
};

export default App;
